/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import auth from '@/plugins/auth-helpers/auth';

export default auth
